import { render, staticRenderFns } from "./LabaRugi.vue?vue&type=template&id=392a726d&scoped=true"
import script from "./LabaRugi.vue?vue&type=script&lang=js"
export * from "./LabaRugi.vue?vue&type=script&lang=js"
import style0 from "./LabaRugi.vue?vue&type=style&index=0&id=392a726d&prod&lang=css"
import style1 from "./LabaRugi.vue?vue&type=style&index=1&id=392a726d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392a726d",
  null
  
)

export default component.exports